import { Button } from '@/components/atoms/Button';
import Image from 'next/image';

interface SelectedFilterOptionProps {
  filterId: string;
  option: {
    name: string;
    selected: boolean;
  };
  isLongText: boolean;
  onChangeCheckedTempFilter: (filterId: string, optionName: string) => void;
}

export function SelectedFilterOption({
  filterId,
  option,
  isLongText,
  onChangeCheckedTempFilter,
}: SelectedFilterOptionProps) {
  return (
    <Button
      key={option.name}
      variant="ghost"
      onClick={() => onChangeCheckedTempFilter(filterId, option.name)}
      className={`h-8 justify-start ${isLongText ? 'col-span-2' : 'col-span-1'} ${
        option.selected
          ? 'text-(--secondary-800) body-14sb' // 18b로 사용 시 width 넘어가는 텍스트 때문에 14sb로
          : 'text-(--secondary-500) body-14m'
      }`}
    >
      {option.name}
      {option.selected && (
        <Image
          src="/images/check-bold.svg"
          alt="check"
          width={20}
          height={20}
        />
      )}
    </Button>
  );
}
